import React, { useContext } from 'react';
export var SpecificationContext = React.createContext(null);
export function useSpec() {
    return useContext(SpecificationContext);
}
//# sourceMappingURL=useSpec.js.map